<div class="row mr-0">
  <div class="col content-block">
    Compliance<br/>
    - documents<br/>
    --jan-2021<br/>
  </div>
</div>
